import { render } from "./ConfirmOtpPage.vue?vue&type=template&id=e795edc2&scoped=true&ts=true"
import script from "./ConfirmOtpPage.vue?vue&type=script&lang=ts"
export * from "./ConfirmOtpPage.vue?vue&type=script&lang=ts"

import "./ConfirmOtpPage.vue?vue&type=style&index=0&id=e795edc2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e795edc2"]])

export default __exports__